module.exports = __webpack_public_path__ + "media/images/flags/32/Saint-Lucia-ba51d22b6abcf617928dd4bcea04ac91.png";